export enum ADDRESSES_FIELDS_NAME {
	ID = 'id',
	CITY = 'city',
	STREET_TYPE = 'streetType',
	STREET = 'street',
	HOUSE = 'house',
	FLAT = 'flat',
	CREATED_AT = 'createdAt',
}

export enum STREETS_FIELDS_NAME {
	ID = 'id',
	NAME = 'name',
	COMMENT = 'comment',
	STREET_TYPE_SHOR_NAME = 'shorName',
	CITY_SHOR_PREFIX = 'city.shorPrefix',
	CITY_PREFIX = 'city.prefix',
	CREATE_AT = 'createdAt',
	UPDATE_AT = 'updatedAt',
	NAME_STREET_TYPE = 'streetType.name',
	NAME_CITY = 'city.name'
}

export enum ALIASES_BY_PROVIDER_FIELDS_NAME {
	ID = 'id',
	NAME = 'name',
	CITY_NAME_CE = 'cityCE',
	CITY_SHOR_PREFIX_CE = 'cityShorPrefixCE',
	CITY_PREFIX_CE = 'cityPrefixCE',
	STREET_TYPE_NAME_CE = 'streetType.name',
	STREET_TYPE_NAME = 'streetType',
	STREET_ID = 'streetId',
	CITY_NAME = 'city',
	STREET = 'street',
	PROVIDER = 'provider.name',
	CREATE_AT = 'createdAt',
	UPDATE_AT = 'updatedAt',
}

export enum CITIES_FIELDS_NAME {
	ID = 'id',
	NAME = 'name',
	PREFIX = 'prefix',
	SHOR_PREFIX = 'shorPrefix',
	REGION_ID = 'regionId',
	REGION_NAME = 'region.name',
}

export enum CITY_ALIASES_BY_PROVIDER_FIELDS_NAME {
	ID = 'id',
	NAME = 'name',
	CITY_ID = 'cityId',
	CITY_NAME = 'city.name',
	PROVIDER_NAME = 'provider.name',
	CREATED_AT = 'createdAt',
	UPDATED_AT = 'updatedAt',
}

export enum SPECIFY_DATA_FIELDS_NAME {
	STREET_TYPE = 'streetType',
	STREET = 'street',
	HOUSE = 'house',
	FLAT = 'flat',
	PROVIDER_TYPE = 'providerType',
}

export enum REJECTED_DATA_FIELDS_NAME {
	CITY = 'city',
	STREET_TYPE = 'streetType',
	STREET = 'street',
	HOUSE = 'house',
	FLAT = 'flat',
	SERVICES_CODE = 'serviceCode',
	SERVICES_NAME = 'serviceName',
	EXTRA_DATA = 'extraData',
	PROVIDER = 'provider',
	REASON = 'reasons',
	PROVIDER_ACCOUNT_ID = 'providerAccountId',
	CREATED_AT = 'createdAt',
}

export enum USERS_FIELDS_NAME {
	ID = 'id',
	FIRST_NAME = 'firstName',
	EMAIL = 'email',
	PHONE = 'phone',
	STATUS = 'status',
	ROLE = 'type',
	UPDATED_AT = 'updatedAt',
}

export enum USER_ACTIVITY_FIELD_NAME {
	DATE = 'createdAt',
	TIME = 'time',
	METHOD = 'method',
	REQUEST = 'request',
	RESPONSE = 'response',
}

export enum CLIENTS_FIELDS_NAME {
	ID = 'id',
	NAME = 'name',
	EMAIL = 'email',
	UPDATED_AT = 'updatedAt',
}

export enum SERVICES_FIELDS_NAME {
	ID = 'id',
	PARTNER_ID = 'payeeId',
	NAME = 'name',
	STATUS = 'status',
	CREATED_AT = 'createdAt',
}

export enum PROVIDERS_FIELDS_NAME {
	PROVIDER = 'provider',
	STATUS = 'status',
	CREATED_AT = 'createdAt',
}

export enum CATEGORIES_FIELDS_NAME {
	ID = 'id',
	NAME = 'name',
	CREATED_AT = 'createdAt',
	SEQUENCE_NUMBER = 'sequenceNumber',
	SERVICES_COUNT = 'servicesCount'
}

export enum SINGLE_RECEIPTS_FIELDS_NAME {
	ID = 'id',
	APARTMENT_ACCOUNT_ID = 'apartmentAccountId',
	CITY = 'city',
	ADDRESS = 'address',
	STATUS = 'status',
	BALANCE = 'balance',
	CREATED_AT = 'createdAt',
	UPDATED_AT = 'updatedAt',
}

export enum OTHER_RECEIPTS_FIELDS_NAME {
	BILL_ID = 'billId',
	PARTNER_ID = 'providerBillId',
	PROVIDER_SERVICE = 'providerService',
	USER_ID = 'userId',
	AMOUNT = 'amount',
	FEE = 'fee',
	PAID_AMOUNT = 'paidAmount',
	STATUS = 'status',
	CARD = 'cardPanMasked',
	REQ_DATA = 'reqData',
	CREATED_AT = 'createdAt',
	PAID_AT = 'paidAt',
}

export enum PAYMENT_FIELDS_NAME {
	PAYMENT_ID = 'paymentId',
	BILL_ID = 'externalId',
	SUM_TRANSACTION = 'amount',
	FEE = 'fee',
	STATUS = 'status',
	PAN = 'cardPanMasked',
	PROVIDER = 'provider',
	TERMINAL = 'terminal',
	PAYMENT_AT = 'paidAt',
	CREATED_AT = 'createdAt',
}


export enum SERVICE_PAYMENTS_FIELD_NAME {
	CREATED_AT = 'createdAt',
	PAID_AT = 'paidAt',
	PARTNER = 'provider',
	MAIN_BILL_ID = 'mainBillId',
	SEPARATION_TYPE = 'separationType',
	SERVICE_PROVIDER = 'serviceTitle',
	SERVICE_NAME = 'serviceName',
	CHILD_BILL_ID = 'id',
	PARENT_BILL_ID = 'parentBillId',
	BANK = 'paymentProvider',
	AMOUNT = 'amount',
	FEE = 'fee',
	PAID_AMOUNT = 'paidAmount',
	STATUS = 'status',
	CLIENT_PHONE = 'phone',
	CARD = 'cardPanMasked',
}
